/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  Product,
  ProductCreateRequest,
  ProductHscodeFeedback,
  ProductHscodeFeedbackCreateRequest,
  ProductSaveResponse,
  ProductsDeleteDestroy200,
  ProductsFeedbackCreateParams,
  ProductsFeedbackListParams,
  ProductsMyProductsListParams
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Delete a product. Only the owner can delete their company's products.
 * @summary Delete product
 */
export const productsDeleteDestroy = (
    id: number,
 ) => {
      
      
      return customInstance<ProductsDeleteDestroy200>(
      {url: `/api/v1/products/${id}/delete/`, method: 'DELETE'
    },
      );
    }
  


export const getProductsDeleteDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsDeleteDestroy>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof productsDeleteDestroy>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof productsDeleteDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  productsDeleteDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProductsDeleteDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof productsDeleteDestroy>>>
    
    export type ProductsDeleteDestroyMutationError = void

    /**
 * @summary Delete product
 */
export const useProductsDeleteDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsDeleteDestroy>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof productsDeleteDestroy>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getProductsDeleteDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get a specific product by ID
 * @summary Get product by ID
 */
export const productsDetailRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<Product>(
      {url: `/api/v1/products/${id}/detail/`, method: 'GET', signal
    },
      );
    }
  

export const getProductsDetailRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/products/${id}/detail/`] as const;
    }

    
export const getProductsDetailRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof productsDetailRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsDetailRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductsDetailRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof productsDetailRetrieve>>> = ({ signal }) => productsDetailRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof productsDetailRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ProductsDetailRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof productsDetailRetrieve>>>
export type ProductsDetailRetrieveQueryError = void

/**
 * @summary Get product by ID
 */
export const useProductsDetailRetrieve = <TData = Awaited<ReturnType<typeof productsDetailRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsDetailRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getProductsDetailRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Update a product. Only the owner can update their company's products.
 * @summary Update product
 */
export const productsUpdateUpdate = (
    id: number,
    productCreateRequest: ProductCreateRequest,
 ) => {
      
      
      return customInstance<ProductSaveResponse>(
      {url: `/api/v1/products/${id}/update/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: productCreateRequest
    },
      );
    }
  


export const getProductsUpdateUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsUpdateUpdate>>, TError,{id: number;data: ProductCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof productsUpdateUpdate>>, TError,{id: number;data: ProductCreateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof productsUpdateUpdate>>, {id: number;data: ProductCreateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  productsUpdateUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProductsUpdateUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof productsUpdateUpdate>>>
    export type ProductsUpdateUpdateMutationBody = ProductCreateRequest
    export type ProductsUpdateUpdateMutationError = void

    /**
 * @summary Update product
 */
export const useProductsUpdateUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsUpdateUpdate>>, TError,{id: number;data: ProductCreateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof productsUpdateUpdate>>,
        TError,
        {id: number;data: ProductCreateRequest},
        TContext
      > => {

      const mutationOptions = getProductsUpdateUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Create a new product for the owner's company
 * @summary Create product
 */
export const productsCreateCreate = (
    productCreateRequest: ProductCreateRequest,
 ) => {
      
      
      return customInstance<ProductSaveResponse>(
      {url: `/api/v1/products/create/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productCreateRequest
    },
      );
    }
  


export const getProductsCreateCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsCreateCreate>>, TError,{data: ProductCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof productsCreateCreate>>, TError,{data: ProductCreateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof productsCreateCreate>>, {data: ProductCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  productsCreateCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProductsCreateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof productsCreateCreate>>>
    export type ProductsCreateCreateMutationBody = ProductCreateRequest
    export type ProductsCreateCreateMutationError = void

    /**
 * @summary Create product
 */
export const useProductsCreateCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsCreateCreate>>, TError,{data: ProductCreateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof productsCreateCreate>>,
        TError,
        {data: ProductCreateRequest},
        TContext
      > => {

      const mutationOptions = getProductsCreateCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * POST: Submit feedback that the given product name and HS code have an error. GET: List feedbacks submitted by the current user. Paginated.
 * @summary Report product name / HS code error (POST) or list my feedbacks (GET)
 */
export const productsFeedbackList = (
    params?: ProductsFeedbackListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ProductHscodeFeedback[] | ProductHscodeFeedback>(
      {url: `/api/v1/products/feedback/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getProductsFeedbackListQueryKey = (params?: ProductsFeedbackListParams,) => {
    return [`/api/v1/products/feedback/`, ...(params ? [params]: [])] as const;
    }

    
export const getProductsFeedbackListQueryOptions = <TData = Awaited<ReturnType<typeof productsFeedbackList>>, TError = void>(params?: ProductsFeedbackListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsFeedbackList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductsFeedbackListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof productsFeedbackList>>> = ({ signal }) => productsFeedbackList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof productsFeedbackList>>, TError, TData> & { queryKey: QueryKey }
}

export type ProductsFeedbackListQueryResult = NonNullable<Awaited<ReturnType<typeof productsFeedbackList>>>
export type ProductsFeedbackListQueryError = void

/**
 * @summary Report product name / HS code error (POST) or list my feedbacks (GET)
 */
export const useProductsFeedbackList = <TData = Awaited<ReturnType<typeof productsFeedbackList>>, TError = void>(
 params?: ProductsFeedbackListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsFeedbackList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getProductsFeedbackListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * POST: Submit feedback that the given product name and HS code have an error. GET: List feedbacks submitted by the current user. Paginated.
 * @summary Report product name / HS code error (POST) or list my feedbacks (GET)
 */
export const productsFeedbackCreate = (
    productHscodeFeedbackCreateRequest: ProductHscodeFeedbackCreateRequest,
    params?: ProductsFeedbackCreateParams,
 ) => {
      
      
      return customInstance<ProductHscodeFeedback[] | ProductHscodeFeedback>(
      {url: `/api/v1/products/feedback/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productHscodeFeedbackCreateRequest,
        params
    },
      );
    }
  


export const getProductsFeedbackCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsFeedbackCreate>>, TError,{data: ProductHscodeFeedbackCreateRequest;params?: ProductsFeedbackCreateParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof productsFeedbackCreate>>, TError,{data: ProductHscodeFeedbackCreateRequest;params?: ProductsFeedbackCreateParams}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof productsFeedbackCreate>>, {data: ProductHscodeFeedbackCreateRequest;params?: ProductsFeedbackCreateParams}> = (props) => {
          const {data,params} = props ?? {};

          return  productsFeedbackCreate(data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProductsFeedbackCreateMutationResult = NonNullable<Awaited<ReturnType<typeof productsFeedbackCreate>>>
    export type ProductsFeedbackCreateMutationBody = ProductHscodeFeedbackCreateRequest
    export type ProductsFeedbackCreateMutationError = void

    /**
 * @summary Report product name / HS code error (POST) or list my feedbacks (GET)
 */
export const useProductsFeedbackCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsFeedbackCreate>>, TError,{data: ProductHscodeFeedbackCreateRequest;params?: ProductsFeedbackCreateParams}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof productsFeedbackCreate>>,
        TError,
        {data: ProductHscodeFeedbackCreateRequest;params?: ProductsFeedbackCreateParams},
        TContext
      > => {

      const mutationOptions = getProductsFeedbackCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get all products for the owner's company. Optional search on name, category, hsCode. Paginated.
 * @summary Get my products
 */
export const productsMyProductsList = (
    params?: ProductsMyProductsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<Product[]>(
      {url: `/api/v1/products/myProducts/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getProductsMyProductsListQueryKey = (params?: ProductsMyProductsListParams,) => {
    return [`/api/v1/products/myProducts/`, ...(params ? [params]: [])] as const;
    }

    
export const getProductsMyProductsListQueryOptions = <TData = Awaited<ReturnType<typeof productsMyProductsList>>, TError = unknown>(params?: ProductsMyProductsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsMyProductsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductsMyProductsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof productsMyProductsList>>> = ({ signal }) => productsMyProductsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof productsMyProductsList>>, TError, TData> & { queryKey: QueryKey }
}

export type ProductsMyProductsListQueryResult = NonNullable<Awaited<ReturnType<typeof productsMyProductsList>>>
export type ProductsMyProductsListQueryError = unknown

/**
 * @summary Get my products
 */
export const useProductsMyProductsList = <TData = Awaited<ReturnType<typeof productsMyProductsList>>, TError = unknown>(
 params?: ProductsMyProductsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsMyProductsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getProductsMyProductsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



